const principles = [
  {
    icon: "ri-stack-line",
    title: "Clean Architecture",
    label: "Foundation",
    body: "Systems are designed with clear separation of concerns, modular components, and well-defined interfaces — ensuring long-term maintainability and ease of evolution as requirements change over time.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Performance Optimization",
    label: "Efficiency",
    body: "Every system is built with performance as a first-class priority. From algorithmic efficiency to resource management, the team ensures responsive, fluid experiences under real-world conditions.",
  },
  {
    icon: "ri-user-heart-line",
    title: "User-Centered Design",
    label: "Experience",
    body: "Design decisions start with understanding user needs, behaviors, and contexts. The result is software that feels intuitive, accessible, and genuinely useful to the people who rely on it.",
  },
  {
    icon: "ri-loop-left-line",
    title: "Continuous Innovation",
    label: "Evolution",
    body: "The team actively explores emerging technologies and evolves internal processes to maintain high technical excellence — never settling for yesterday's solutions to tomorrow's challenges.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Technical Excellence",
    label: "Quality",
    body: "Rigorous testing, code review, and quality assurance practices ensure every deliverable meets the highest standards of reliability, security, and long-term stability.",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "Scalable Systems",
    label: "Growth",
    body: "Architecture decisions account for future growth from day one — enabling systems to handle increasing complexity and user bases without compromising performance or reliability.",
  },
];

export default function StandardsSection() {
  return (
    <section className="relative w-full bg-background-200/70 py-24 md:py-32 lg:py-40 px-8 md:px-16 lg:px-24">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-4">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-sm font-medium text-foreground-600 font-label">
            Engineering Standards
          </span>
        </div>

        <h2 className="text-[clamp(32px,4.4vw,52px)] font-bold text-foreground-950 font-heading leading-[1.15] max-w-2xl">
          How we build
          <br />
          lasting software
        </h2>

        <div className="mt-16 md:mt-24 columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5">
          {principles.map((item, idx) => (
            <div
              key={idx}
              className="break-inside-avoid bg-background-50 rounded-xl p-6 md:p-7"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-background-200/80 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-lg text-primary-500`}></i>
                </div>
                <div>
                  <h4 className="text-base md:text-lg font-semibold text-foreground-950 font-heading leading-tight">
                    {item.title}
                  </h4>
                  <span className="text-xs text-foreground-400 font-label">
                    &mdash; {item.label}
                  </span>
                </div>
              </div>
              <p className="mt-5 text-sm md:text-[15px] text-foreground-600 leading-relaxed">
                <span className="text-primary-400 text-lg leading-none">&ldquo;</span>
                {item.body}
                <span className="text-primary-400 text-lg leading-none">&rdquo;</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}